import { ref } from "vue";
import { createRouter, createWebHistory, } from "vue-router";
import { getUser, setUserFromToken, hasPermission, } from "@/store/userStore";
import { config } from "@/config";
import Swal from "sweetalert2";
import { authService } from "../services/AuthService";
import Login from "../views/login/index.vue";
import recoverPassword from "../views/recoverPassword/index.vue";
import resetPassword from "../views/resetPassword/index.vue";
import Home from "../views/home/index.vue";
import Panel from "../views/dashboard/index.vue";
import Productos from "../views/productos/index.vue";
import ProductoDetalle from "../views/productoDetalle/index.vue";
import ProductoAdd from "../views/productos/add/index.vue";
import Repuestos from "../views/repuestos/index.vue";
import Perfil from "../views/perfil/index.vue";
import Contacto from "../views/contacto/index.vue";
import ListaProductos from "../views/listaProductos/index.vue";
import SearchResults from "../views/search/index.vue";
import Pedidos from "../views/orders/index.vue";
import Clientes from "../views/clients/index.vue";
import MisPedidos from "../views/misPedidos/index.vue";
import Pagos from "../views/pago/index.vue";
import aprobarPagos from "../views/aprobarPagos/index.vue";
import historialPagos from "../views/historialPagos/index.vue";
import GestionPedidos from "../views/gestionPedidos/index.vue";
import OrdenDesplegables from "../views/ordenDesplegables/index.vue";
import Desplegables from "../views/desplegables/index.vue";
import Equivalentes from "../views/equivalentes/index.vue";
import Departamentos from "../views/departamentos/index.vue";
import Categorias from "../views/categorias/index.vue";
import Proveedores from "../views/suppliers/index.vue";
import Usuarios from "../views/usuarios/index.vue";
import Roles from "../views/roles/index.vue";
import ConfiguracionSistema from "../views/configuracionSistema/index.vue";
import InstrumentosPago from "../views/instrumentosPago/index.vue";
import Aliados from "../views/aliados/index.vue";
import Almacenes from "../views/almacenes/index.vue";
import AccessDenied from "../views/AccessDenied.vue";
import VentasRetailPos from "../views/ventasRetail/index.vue";
import VentasRetailComanda from "../views/ventasRetail/comanda/index.vue";
import VentasRetailCaja from "../views/ventasRetail/caja/index.vue";
import NotasCredito from "../views/notasCredito/index.vue";
import ComprasPrincipal from "../views/compras/index.vue";
import ModuloPrecios from "../views/precios/index.vue";
const routes = [
    { path: "/", name: "Home", component: Home },
    { path: "/login", name: "Login", component: Login },
    {
        path: "/recover-passwword",
        name: "recoverPassword",
        component: recoverPassword,
    },
    {
        path: "/reset-password",
        name: "resetPassword",
        component: resetPassword,
        props: true,
    },
    {
        path: "/search",
        name: "SearchResults",
        component: SearchResults,
        props: (route) => ({ query: route.query.q }), // Pasar el término de búsqueda como prop
    },
    {
        path: "/panel",
        name: "Panel",
        component: Panel,
        meta: { requiresAuth: true, permission: "INDICADORES_VIEW" },
    },
    {
        path: "/perfil",
        name: "Perfil",
        component: Perfil,
        meta: { requiresAuth: true },
    },
    {
        path: "/contacto",
        name: "Contacto",
        component: Contacto,
    },
    {
        path: "/mis-pedidos",
        name: "MisPedidos",
        component: MisPedidos,
        meta: { requiresAuth: true },
    },
    {
        path: "/productos",
        name: "ListaProductos",
        component: ListaProductos,
        props: (route) => ({ query: route.query.q }),
    },
    {
        path: "/p/:id",
        name: "ProductoDetalle",
        component: ProductoDetalle,
        props: true,
    },
    {
        path: "/panel/productos",
        name: "Productos",
        component: Productos,
        meta: { requiresAuth: true, permission: "PROD_VIEW" },
    },
    {
        path: "/panel/clientes",
        name: "Clientes",
        component: Clientes,
        meta: { requiresAuth: true, permission: "CLIENTE_VIEW" },
    },
    {
        path: "/panel/proveedores",
        name: "Proveedores",
        component: Proveedores,
        meta: { requiresAuth: true, permission: "PROV_VIEW" },
    },
    {
        path: "/panel/mantenimiento/usuarios",
        name: "Usuarios",
        component: Usuarios,
        meta: { requiresAuth: true, permission: "USER_VIEW" },
    },
    {
        path: "/panel/pedidos",
        name: "Pedidos",
        component: Pedidos,
        meta: { requiresAuth: true, permission: "ORD_VIEW" },
    },
    {
        path: "/panel/pedidos/:pedidoId/pago",
        name: "Pagos",
        component: Pagos,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: "/panel/gestion/aprobar-pagos",
        name: "AprobarPagos",
        component: aprobarPagos,
        meta: { requiresAuth: true, permission: "PAY_APPROVE" },
        props: true,
    },
    {
        path: "/panel/gestion/historial-pagos",
        name: "HistorialPagos",
        component: historialPagos,
        meta: { requiresAuth: true, permission: "PAY_HISTORY" },
        props: true,
    },
    {
        path: "/panel/gestion/pedidos",
        name: "GestionPedidos",
        component: GestionPedidos,
        meta: { requiresAuth: true, permission: "ORD_MANAGE" },
        props: true,
    },
    {
        path: "/panel/producto/add",
        name: "ProductoAdd",
        component: ProductoAdd,
        meta: { requiresAuth: true, permission: "PROD_CREATE" },
    },
    {
        path: "/panel/producto/edit/:id",
        name: "ProductoEdit",
        component: ProductoAdd, // Reusing the same component
        meta: { requiresAuth: true, permission: "PROD_EDIT" },
        props: true
    },
    {
        path: "/panel/mantenimiento/desplegables",
        name: "Desplegables",
        component: Desplegables,
        meta: { requiresAuth: true, permission: "CONFIG_DESPLEGABLES_VIEW" },
    },
    {
        path: "/panel/mantenimiento/repuestos",
        name: "Repuestos",
        component: Repuestos,
        meta: { requiresAuth: true, permission: "REPUESTO_VIEW" },
    },
    {
        path: "/panel/mantenimiento/orden-desplegables",
        name: "OrdenDesplegables",
        component: OrdenDesplegables,
        meta: { requiresAuth: true, permission: "CONFIG_DESPLEGABLES_VIEW" },
    },
    {
        path: "/panel/mantenimiento/equivalentes",
        name: "Equivalentes",
        component: Equivalentes,
        meta: { requiresAuth: true, permission: "EQUIVALENTE_VIEW" },
    },
    {
        path: "/panel/mantenimiento/departamentos",
        name: "Departamentos",
        component: Departamentos,
        meta: { requiresAuth: true, permission: "CONFIG_DEPARTAMENTOS_VIEW" },
    },
    {
        path: "/panel/mantenimiento/categorias",
        name: "Categorias",
        component: Categorias,
        meta: { requiresAuth: true, permission: "CONFIG_CATEGORIAS_VIEW" },
    },
    {
        path: "/panel/mantenimiento/roles",
        name: "Roles",
        component: Roles,
        meta: { requiresAuth: true, permission: "ROLE_MANAGE" },
    },
    {
        path: "/panel/mantenimiento/configuracion-sistema",
        name: "ConfiguracionSistema",
        component: ConfiguracionSistema,
        meta: { requiresAuth: true, permission: "CONFIG_SISTEMA_VIEW" },
    },
    {
        path: "/panel/mantenimiento/instrumentos-pago",
        name: "InstrumentosPago",
        component: InstrumentosPago,
        meta: { requiresAuth: true, permission: "CONFIG_PAGOS_VIEW" },
    },
    {
        path: "/panel/mantenimiento/almacenes",
        name: "Almacenes",
        component: Almacenes,
        meta: { requiresAuth: true, permission: "ALMACEN_VIEW" },
    },
    {
        path: "/panel/mantenimiento/red-aliada",
        name: "RedAliada",
        component: Aliados,
        meta: { requiresAuth: true, permission: "RED_ALIADA_VIEW" },
    },
    {
        path: "/panel/ventas-retail",
        name: "VentasRetail",
        component: VentasRetailPos,
        meta: { requiresAuth: true, permission: "VENTA_RETAIL_VIEW" },
    },
    {
        path: "/panel/ventas-retail/comanda",
        name: "VentasRetailComanda",
        component: VentasRetailComanda,
        meta: { requiresAuth: true, permission: "VENTA_RETAIL_COMANDA" },
    },
    {
        path: "/panel/ventas-retail/caja",
        name: "VentasRetailCaja",
        component: VentasRetailCaja,
        meta: { requiresAuth: true, permission: "VENTA_RETAIL_CAJA" },
    },
    {
        path: "/panel/ventas-retail/en-vivo",
        name: "VentasRetailEnVivo",
        component: () => import("../views/ventasRetail/enVivo/index.vue"),
        meta: { requiresAuth: true, permission: "VENTA_RETAIL_EN_VIVO" },
    },
    {
        path: "/panel/compras",
        name: "ComprasPrincipal",
        component: ComprasPrincipal,
        meta: { requiresAuth: true, permission: "COMPRAS_PEDIDOS" }, // O verificar internamente
    },
    {
        path: "/panel/notas-credito",
        name: "NotasCredito",
        component: NotasCredito,
        meta: { requiresAuth: true, permission: "NOTA_CREDITO_VIEW" },
    },
    {
        path: "/panel/precios",
        name: "ModuloPrecios",
        component: ModuloPrecios,
        meta: { requiresAuth: true, permission: "PRECIOS_VIEW" },
    },
    {
        path: "/panel/access-denied",
        name: "AccessDenied",
        component: AccessDenied,
    },
];
const user = ref(null);
const updateUser = async () => {
    user.value = getUser();
    if (!user.value) {
        const token = localStorage.getItem("accessToken");
        if (token) {
            await setUserFromToken(token);
            user.value = getUser();
        }
    }
};
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});
// Función para validar la estructura de un token JWT
function isValidToken(token) {
    if (!token)
        return false;
    // Un token JWT debe tener tres partes separadas por puntos
    const parts = token.split(".");
    return parts.length === 3;
}
router.beforeEach(async (to, from, next) => {
    let accessToken = localStorage.getItem("accessToken");
    let refreshToken = localStorage.getItem("refreshToken");
    // Validar los tokens y eliminarlos si no tienen una estructura válida
    if (!isValidToken(accessToken)) {
        localStorage.removeItem("accessToken");
        accessToken = null;
    }
    // Si hay un accessToken, verificar su validez
    if (accessToken) {
        try {
            const response = await fetch(`${config.API_URL}/api/Auth/verify-token`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (response.status !== 200) {
                // Si el token no es válido, eliminarlo
                localStorage.removeItem("accessToken");
                accessToken = null;
            }
        }
        catch (error) {
            // En caso de error, también eliminar el token
            localStorage.removeItem("accessToken");
            accessToken = null;
        }
    }
    // Si el usuario está autenticado y trata de ir al login, redirigir al Home
    if (accessToken && refreshToken && to.name === "Login") {
        return next({ name: "Home" });
    }
    if (to.meta.requiresAuth) {
        if (!accessToken || !refreshToken) {
            await Swal.fire({
                icon: "warning",
                title: "Acceso Restringido",
                text: "Debes iniciar sesión para acceder a esta página.",
                confirmButtonText: "Aceptar",
            });
            return next({ name: "Login" });
        }
        // if (to.path === "/dashboard") {
        //   if (user.value?.isAdmin?.toLowerCase() === "true") {
        //     return next(); // Permite acceso al Dashboard si es admin
        //   } else {
        //     return next({ name: "Pedidos" }); // Redirige a Pedidos si no es admin
        //   }
        // }
        try {
            // Actualiza el usuario antes de verificar el token
            await updateUser();
            // Verifica si el token es válido
            const response = await fetch(`${config.API_URL}/api/Auth/verify-token`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (response.status === 401) {
                // Token expirado, intenta refrescarlo
                const refreshResponse = await authService.refreshToken();
                localStorage.setItem("accessToken", refreshResponse.AccessToken);
                localStorage.setItem("refreshToken", refreshResponse.RefreshToken);
                // Actualiza el usuario con el nuevo token
                await setUserFromToken(refreshResponse.AccessToken);
                user.value = getUser();
                // Vuelve a intentar la solicitud con el nuevo token
                return next({ ...to, replace: true });
            }
            // Verifica el rol de administrador si es necesario
            // Verifica el rol de administrador o permisos específicos
            const isAdmin = user.value?.isAdmin?.toString().toLowerCase() === "true";
            if (to.meta.requiresAdmin && !isAdmin) {
                return next({ name: "AccessDenied" });
            }
            if (to.meta.permission && !isAdmin) {
                if (!hasPermission(to.meta.permission)) {
                    return next({ name: "AccessDenied" });
                }
            }
            // Permite el acceso
            next();
        }
        catch (error) {
            await Swal.fire({
                icon: "error",
                title: "Error",
                text: "Se produjo un error al intentar acceder a la página.",
                confirmButtonText: "Aceptar",
            });
            next({ name: "Login" });
        }
    }
    else {
        next(); // Permite el acceso a rutas que no requieren autenticación
    }
});
export default router;
